
export default {
  init() {
   /*
    console.log('entro en js de musicales');
    $('video').on('mouseover', function() {
      this.play();
      console.log(this);
    }, function() {
      this.pause()
    });

     $('.seccion-video video').on('mouseover mouseout', function(e) {
      let varAncho = $(window).width();
      const evt = e.type;
      if(varAncho >= 768) {
        if (evt === 'mouseover') {
          this.play();
        }
        if (evt === 'mouseout') {
          this.pause();
        }
      }
     
      
    }); */

    $('a[href^="#"]').on('click',function() {
      var destino = $(this.hash);
      if (destino.length == 0) {
        destino = $('a[name="' + this.hash.substr(1) + '"]');
      }
      if (destino.length == 0) {
        destino = $('html');
      }
      $('html, body').animate({ scrollTop: destino.offset().top }, 500);
      $('.ficha-musical').removeClass('add-crecimiento');
      $('.texto-intro').css('display','none');
      $('.seccion-video-ficha video').trigger('pause');
      return false;
    });

 $('.ficha-musical').on('click', function() {


    let miVarClass = $(this).hasClass('add-crecimiento');
    console.log(miVarClass);
    let miVideo = $('.seccion-video-ficha video',this);

    $('.ficha-musical video').trigger('stop');
    if(miVarClass != false) {
      console.log('elimino la clase');
      $('.ficha-musical').removeClass('add-crecimiento');
      $('.texto-intro',this).css('display','none');
      miVideo.trigger('pause');
    } else {
      console.log('agrego la vlase la clase');
      $('.texto-intro').css('display','none');
      $('.ficha-musical').removeClass('add-crecimiento');
      $('.texto-intro',this).css('display','flex');
      $(this).addClass('add-crecimiento');
      $('.seccion-video-ficha video').trigger('pause');
      console.log(miVideo)
      miVideo.trigger('play');
    }
      
    });
 

     
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-musicales.js